const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-flight-takeoff-line',
      title: 'Traslados Aeropuerto',
      description: 'Servicio de recogida y entrega en aeropuerto para grupos de 8 a 19 personas. Seguimiento de vuelos incluido.',
      features: ['Seguimiento de vuelos', 'Conductor profesional', 'Aire acondicionado', 'WiFi gratuito']
    },
    {
      icon: 'ri-group-line',
      title: 'Grupos Empresariales',
      description: 'Transporte corporativo para equipos, reuniones y eventos empresariales con microbuses de lujo.',
      features: ['Facturación empresarial', 'Servicio puntual', 'Vehículos premium', 'Conductor uniforme']
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Eventos y Celebraciones',
      description: 'Perfecto para bodas, despedidas, cumpleaños y eventos especiales. Capacidad hasta 19 invitados.',
      features: ['Decoración personalizada', 'Música a bordo', 'Servicio premium', 'Horario flexible']
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Tours Costa del Sol',
      description: 'Excursiones personalizadas por la Costa del Sol en microbús con guía. Ideal para grupos medianos.',
      features: ['Guía turístico', 'Ruta personalizada', 'Paradas libres', 'Grupo hasta 19 pax']
    },
    {
      icon: 'ri-hotel-line',
      title: 'Traslados Hotel',
      description: 'Recogida y entrega en hoteles de la Costa del Sol para grupos. Servicio puerta a puerta.',
      features: ['Recogida puntual', 'Ayuda con equipaje', 'Ruta directa', 'Confirmación previa']
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-lg tracking-wide">SERVICIOS</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Microbuses Especializados
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Servicios de transporte premium con microbuses Mercedes-Benz de 8 a 19 plazas.
            Perfectos para grupos medianos que buscan comodidad y exclusividad.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group"
            >
              {/* Icon */}
              <div className="w-16 h-16 bg-gradient-to-r from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-teal-600 transition-colors">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-3">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <div className="w-5 h-5 bg-teal-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      <i className="ri-check-line text-teal-600 text-xs"></i>
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <button className="mt-6 w-full border-2 border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white px-6 py-3 rounded-lg font-medium transition-all duration-300 group-hover:border-teal-700 group-hover:bg-teal-700 whitespace-nowrap">
                Más Información
              </button>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-lg text-gray-600 mb-6">
            ¿No encuentras lo que buscas? Contáctanos para servicios personalizados
          </p>
          <a 
            href="https://wa.me/34614932797?text=Hola,%20necesito%20información%20sobre%20servicios%20personalizados%20de%20transporte%20para%20grupos"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            Contactar Ahora
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;